import { Col } from '@/components/ui/col'
export function PosMockupScreenTpc() {
  return (
    <Col className="relative flex h-full w-1/3 bg-white">
      <div className="flex h-14 flex-shrink-0 items-center justify-between border-b border-tpc-dark bg-tpc px-4 text-white">
        <div className="flex items-center gap-4">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white p-1 shadow-sm">
            <div className="flex h-full w-full items-center justify-center rounded-full border-2 border-tpc bg-white">
              <div className="h-3 w-3 rotate-45 rounded-sm bg-brand-red" />
            </div>
          </div>
          <Col className="">
            <span className="mt-1 text-lg font-bold leading-none tracking-wide">TPC POS System</span>
            <span className="mt-0.5 font-mono text-fs-md text-white/80">TPC Vincom | Store #042</span>
          </Col>
        </div>
        <div className="flex items-center gap-6 font-mono text-xs text-white/90">
          <span className="hidden sm:inline-block">
            Máy POS: <strong>P-02</strong>
          </span>
          <span className="hidden sm:inline-block">
            Thu ngân: <strong>Minh T.</strong>
          </span>
          <span className="pos-time rounded bg-tpc-dark px-3 py-1.5 text-sm font-bold text-white shadow-inner">
            --:--:--
          </span>
        </div>
      </div>

      <div className="relative flex flex-1 overflow-hidden">
        <Col className="flex flex-1 overflow-hidden border-r border-gray-200 bg-gray-50">
          <div className="mock-scroll flex flex-shrink-0 gap-2 overflow-x-auto border-b border-gray-200 bg-white p-3">
            <button
              type="button"
              className="flex-shrink-0 rounded bg-tpc px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-white"
            >
              Pizza (Signature)
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-tpc hover:text-tpc"
            >
              Pasta
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-tpc hover:text-tpc"
            >
              Appetizers
            </button>
            <button
              type="button"
              className="flex-shrink-0 rounded border border-gray-300 bg-white px-5 py-2.5 text-xs font-bold uppercase tracking-wide text-charcoal-600 hover:border-tpc hover:text-tpc"
            >
              Drinks
            </button>
          </div>

          <div className="mock-scroll grid grid-cols-2 content-start gap-3 overflow-y-auto bg-gray-100/50 p-4 lg:grid-cols-3">
            <Col className="flex h-28 cursor-pointer justify-between border-t-4 border-t-tpc rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Hải Sản Pesto Xanh</span>
              <span className="mt-2 font-mono text-sm font-bold text-tpc">279,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between border-t-4 border-t-tpc rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Hải Sản Nhiệt Đới</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">279,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between border-t-4 border-t-tpc rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Siêu Tối Thượng</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">259,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Mỳ Ý Hải Sản Xốt Kem</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">139,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Cánh Gà BBQ (6 miếng)</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">119,000 ₫</span>
            </Col>
            <Col className="flex h-28 cursor-pointer justify-between rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-tpc hover:shadow">
              <span className="text-sm font-bold leading-tight text-charcoal-900">Bánh Mì Bơ Tỏi</span>
              <span className="mt-2 font-mono text-sm font-bold text-charcoal-600">49,000 ₫</span>
            </Col>
          </div>
        </Col>

        <Col className="z-10 flex w-80 flex-shrink-0 bg-white shadow-[-4px_0_15px_-3px_rgba(0,0,0,0.05)] lg:w-96">
          <div className="flex items-center justify-between border-b border-gray-200 bg-green-50 p-4">
            <Col className="">
              <span className="text-xl font-bold text-charcoal-900">Đơn #5021</span>
              <span className="mt-0.5 font-mono text-fs-md uppercase text-charcoal-500">Bàn 05</span>
            </Col>
            <span className="rounded-md border border-tpc/30 bg-white px-2.5 py-1.5 text-fs-sm font-bold uppercase tracking-widest text-tpc">
              DINE-IN
            </span>
          </div>

          <Col className="mock-scroll flex flex-1 gap-5 overflow-y-auto p-4">
            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  1
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Pizza Hải Sản Pesto Xanh</span>
                  <span className="mt-1 flex items-center gap-1 text-xs text-charcoal-500">
                    <svg className="h-3 w-3 text-tpc" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>{' '}
                    Cỡ Lớn (12&quot;)
                  </span>
                  <span className="mt-0.5 flex items-center gap-1 text-xs text-charcoal-500">
                    <svg className="h-3 w-3 text-tpc" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                    </svg>{' '}
                    Đế Viền Phô Mai (+50,000 ₫)
                  </span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">389,000 ₫</span>
            </div>

            <div className="group flex items-start justify-between">
              <div className="flex gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-gray-200 bg-gray-100 text-sm font-bold text-charcoal-900">
                  2
                </span>
                <Col className="">
                  <span className="text-sm font-bold text-charcoal-900">Mỳ Ý Hải Sản Xốt Kem</span>
                </Col>
              </div>
              <span className="font-mono text-sm font-semibold text-charcoal-900">139,000 ₫</span>
            </div>

            <div className="group flex w-full items-start justify-between">
              <div className="flex flex-1 gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded border border-brand-red/20 bg-brand-red/10 text-sm font-bold text-brand-red">
                  %
                </span>
                <Col className="w-full">
                  <div className="mt-1 flex justify-between">
                    <span className="flex items-center gap-1 text-fs-lg font-bold text-brand-red">
                      Mã: TPC50 (Giảm 50K)
                    </span>
                    <span className="font-mono text-fs-md font-semibold text-brand-red">-50,000 ₫</span>
                  </div>
                </Col>
              </div>
            </div>
          </Col>

          <div className="border-t border-gray-200 bg-gray-50 p-5">
            <div className="mb-2 flex justify-between text-sm text-charcoal-600">
              <span>Tạm tính</span>
              <span className="font-mono">528,000 ₫</span>
            </div>
            <div className="mb-2 flex justify-between text-sm font-medium text-brand-red">
              <span>Giảm giá</span>
              <span className="font-mono">-50,000 ₫</span>
            </div>
            <div className="mb-4 flex justify-between text-sm text-charcoal-600">
              <span>VAT (8%)</span>
              <span className="font-mono">38,240 ₫</span>
            </div>
            <div className="mb-4 h-px w-full bg-gray-200" />
            <div className="mb-6 flex items-end justify-between">
              <span className="text-sm font-bold uppercase tracking-wide text-charcoal-900">Tổng cộng</span>
              <span className="font-mono text-3xl font-bold leading-none text-tpc">516,240 ₫</span>
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                className="w-1/3 rounded-lg border-2 border-gray-300 bg-white py-3.5 text-xs font-bold uppercase tracking-wide text-charcoal-900 transition-colors hover:bg-gray-100"
              >
                LƯU BÀN
              </button>
              <button
                type="button"
                className="w-2/3 rounded-lg bg-tpc py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-lg shadow-tpc/30 transition-all hover:bg-tpc-dark"
              >
                THANH TOÁN
              </button>
            </div>
          </div>
        </Col>
      </div>
    </Col>
  )
}
